import { Component, Inject, OnInit } from '@angular/core';
import {MatDialogRef , MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-quill-editor-dialog',
    templateUrl: './quill-editor-dialog.component.html',
    styleUrls: ['./quill-editor-dialog.component.scss'],
    standalone: false
})
export class QuillEditorDialogComponent implements OnInit {
  quillConfig = {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],
        ['code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ font: [] }],
        [{ align: [] }],
      ],
    },
  };

  constructor(public dialogRef: MatDialogRef<QuillEditorDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: string) { }

  ngOnInit(): void {
    // can perform any logical implemention here if required
  }
  close(): void {
    this.dialogRef.close();
  }
}
